var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scorm-completed"},[_c('h1',[_vm._v("Course Completed")]),_c('p',[_vm._v("Please close this window and return to your Community to view your earned CEU’s and Certificates.")])])
}]

export { render, staticRenderFns }